import { HeatTier } from './heat';

export const BRAND = 'pogchamp.tv';

export interface TitleSubject {
  name: string;
  heat: number;
  tier: HeatTier;
}

/** The tab title: the brand alone, the channel, or the channel led by its heat */
export const formatPageTitle = (subject: TitleSubject | null): string => {
  if (!subject) return BRAND;
  if (subject.tier === 'cold') return `${subject.name} · ${BRAND}`;
  return `🔥 ${subject.heat.toFixed(1)}× ${subject.name} · ${BRAND}`;
};
